import { BASEJUMP_API_URL } from '../constants';

const DEFAULT_PAGE_SIZE = 50;
/*
export const getAllNftsFromAlchemy = async (ownerAddress, contractAddress = null, network = Network.BASE_SEPOLIA) => {
  let tokens = [];
  let pageKey = null;
  const alchemy = new Alchemy({
    apiKey: ALCHEMY_API_KEY,
    network: network
  });

  do {
    const options = {
      contractAddresses: contractAddress ? [contractAddress] : undefined,
      pageKey,
      pageSize: DEFAULT_PAGE_SIZE
    };

    const nfts = await alchemy.nft.getNftsForOwner(ownerAddress, options);
    tokens = [...tokens, ...nfts.ownedNfts];
    pageKey = nfts.pageKey;

  } while (pageKey);

  return tokens;
};
*/

export const getUser = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/my`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to load user!');
  }

  return await response.json();
};

export const getStats = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/stats`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to load user stats!');
  }

  return await response.json();
};

export const getAvatars = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/avatars`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch avatars!');
  }

  const { data } = await response.json();
  return data;
};

export const getDiscordToken = async (code) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/auth/discord_token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      code
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to get Discord Token!');
  }

  const { access_token } = await response.json();
  return access_token;
};

export const loginToBasejump = async (discordToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/auth/discord_login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      access_token: discordToken
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to get Log In!");
  }

  return await response.json();
};

export const createGameSession = async (avatarId, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/sessions`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      avatar_id: avatarId
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to create session!');
  }

  return await response.json();
};

export const listGameSessions = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/sessions`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });

  if (!response.ok) {
    throw new Error('Failed to list sessions!');
  }

  const { data } = await response.json();
  return data;
};

export const joinGameSession = async (sessionId, avatarId, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/sessions/${sessionId}/join`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      avatar_id: avatarId
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to join session!');
  }

  return await response.json();
};

export const getGameSession = async (sessionId, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/sessions/${sessionId}`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });

  if (!response.ok) {
    throw new Error('Failed to get session!');
  }

  return await response.json();
};

export const getLevels = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/levels`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });

  if (!response.ok) {
    throw new Error('Failed to get levels!');
  }

  return await response.json();
};

export const playLevel = async (levelId, avatarId, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/levels/${levelId}/play`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      avatar_id: avatarId
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to start Session');
  }

  return await response.json();
};

export const checkGameSession = async (sessionId, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/sessions/${sessionId}/check`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });

  if (!response.ok) {
    throw new Error('Failed to get session!');
  }

  return await response.json();
};

export const leaveGameSession = async (sessionId, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/sessions/${sessionId}/leave`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });

  if (!response.ok) {
    throw new Error('Failed to leave session!');
  }

  return await response.json();
};

export const getEquipmentItems = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/items`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch avatars!');
  }

  const { data } = await response.json();
  return data;
};

export const setAvatarEquipmentItems = async (avatarId, equipment, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/avatars/${avatarId}/equip`, {
    method: "POST",
    body: JSON.stringify({ equipment }),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    }
  });

  if (!response.ok) {
    throw new Error('Failed to set equipment!');
  }

  return await response.json();
};

export const getEditorItems = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/editor/items`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch items!');
  }

  const { data } = await response.json();
  return data;
};

export const updateEditorItem = async (accessToken, itemId, updateObject) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/editor/items/${itemId}`, {
    method: "PATCH",
    body: JSON.stringify(updateObject),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to update item!');
  }

  return await response.json();
};

export const getShopItems = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/shop`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch shop!');
  }

  const { data } = await response.json();
  return data;
};

export const orderItem = async (accessToken, itemId) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/shop/${itemId}/buy`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to order item!');
  }

  return await response.json();
};

export const consumeItem = async (accessToken, avatarId, itemId) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/avatars/${avatarId}/consume/${itemId}`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to consume item!');
  }

  return await response.json();
}

export const addUserWallets = async (accessToken, wallets) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/add_wallets`, {
    method: "POST",
    body: JSON.stringify({ wallets }),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to set user wallets!');
  }

  return await response.json();
};

export const getUnreadMessages = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/messages`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch unread messages!');
  }

  const { data } = await response.json();
  return data;
};

export const readMessage = async (accessToken, messageId) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/messages/${messageId}/read`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to mark message as read!');
  }

  return await response.json();
};

export const getUploadUrls = async (accessToken, files) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/upload_urls`, {
    method: "POST",
    body: JSON.stringify({ files }),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to get upload urls!');
  }

  return await response.json();
};

export const createAvatar = async (accessToken, avatarData) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/avatars`, {
    method: "POST",
    body: JSON.stringify(avatarData),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to create avatar!');
  }

  return await response.json();
};

export const getLeaderboard = async (accessToken, limit = 50, offset = 0) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/leaderboard?offset=${offset}&limit=${limit}`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to create avatar!');
  }

  const { data } = await response.json();
  return data;
};

export const updateVictoryCaption = async(caption, accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/caption`, {
    method: "PATCH",
    body: JSON.stringify({ caption }),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to update user victory caption!');
  }

  return await response.json();
};

export const getMetrics = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/metrics`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch metrics!');
  }

  return await response.json();
};

export const getShopSkus = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/shop/skus`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch shop SKUs!');
  }

  const { data } = await response.json();
  return data;
};

export const getCheckoutSession = async (accessToken, skuId) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/shop/skus/${skuId}/checkout`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch SKU ${skuId} checkout session`);
  }

  return await response.json();
};

export const getEditorNpcs = async (accessToken) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/editor/npcs`, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch npc avatars!');
  }

  const { data } = await response.json();
  return data;
};

export const updateEditorNpcAvatar = async (accessToken, avatarId, updateObject) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/editor/npcs/${avatarId}`, {
    method: "PATCH",
    body: JSON.stringify(updateObject),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to update npc avatar!');
  }

  return await response.json();
};


export const setTutorialState = async (accessToken, tutorialState) => {
  const response = await fetch(`${BASEJUMP_API_URL}/api/v0/users/tutorial_state`, {
    method: "PATCH",
    body: JSON.stringify({ tutorial_state: tutorialState}),
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error('Failed to update user tutorial state!');
  }

  return await response.json();
};